import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {gsap} from "gsap";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {BruteForce} from "../BruteForce";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {BruteForceGameConfig} from "../BruteForceGameConfig";

export class BruteForceSound {

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";

    //sound loops
    public static MAIN_GAME_MUSIC: string = "main";
    public static BUNKER_SCREEN_MUSIC: string = "bunkerScreen";
    public static FS_MUSIC: string = "fs";
    public static SFS_MUSIC: string = "sfs";
    public static MAIN_GAME_MUSIC_CRUSHED: string = "mainCrushed";
    public static WINCAP_MUSIC_GAMEOVER: string = "winCapLoop";


    //sound effects
    public static GAMEINTRO: string = "gameIntro";
    public static BIG_WIN_LEVELS: string[] = ["bigwinLevel1", "bigwinLevel2", "bigwinLevel3", "bigwinLevel4", "bigwinLevel5"];
    public static BIGWIN_OUTROS: string[] = ["bigwinOutro1", "bigwinOutro2", "bigwinOutro3"];
    public static WIN_TINY: string = "winTiny";
    public static WIN_SMALL: string = "winSmall";
    public static WIN_MIDIEUM: string = "winMid";
    public static WIN_LARGE: string = "winLarge";
    public static NUDGE_LANDING: string[] = ["xNudgeMove1", "xNudgeMove2", "xNudgeMove3"];
    public static NUDGE_SPARKS: string[] = ["xNudgeMovingSparks1", "xNudgeMovingSparks2", "xNudgeMovingSparks3"];
    public static NUDGE_FINAL_LAND: string = "xNudgeMoveLand";
    public static REEL_CRASH: string = "reelCrash";
    public static MOVE_POINTS_TO_COUNTER: string[] = ["xNudgeMovePointsToCounter1", "xNudgeMovePointsToCounter2", "xNudgeMovePointsToCounter3"];
    public static XNUDGE_METER_POINTS: string[] = ["xNudgeMeterPoints1", "xNudgeMeterPoints2", "xNudgeMeterPoints3", "xNudgeMeterPoints4", "xNudgeMeterPoints5"];
    public static NUDGE_POINTS_HIGHLIGHT: string = "xNudgePointsHighlight";
    public static DOOR_OPEN: string = "bunkerDoorOpen";
    public static DOOR_CLOSE: string = "bunkerDoorClose";
    public static NUDGE_LAND: string[] = ["xN1Land", "xN2Land", "xN3Land"];
    public static BETLINE_HIGHLIGHTS: string[] = ["betlineHighlight1", "betlineHighlight2", "betlineHighlight3", "betlineHighlight4", "betlineHighlight5"];
    public static BETLINE_HIGHLIGHTS_OVERLAY_M: string[] = ["betlineHighlightOverlayM1", "betlineHighlightOverlayM2", "betlineHighlightOverlayM3", "betlineHighlightOverlayM4", "betlineHighlightOverlayM5"];
    public static BIGWIN_INTRO: string = "bigwinIntro";
    public static WINCAP_MUSIC: string = "wincapStart";
    public static BIG_WIN_LEVEL_1_NO_COUNTUP: string = "bigwinLevel1NoCountup";
    public static NUDGE_STICKY_FAIL: string[] = ["xNudgeWeapon1StickyFail", "xNudgeWeapon2StickyFail", "xNudgeWeapon3StickyFail"];
    public static NUDGE_STICKY_SUCCESS: string[] = ["xNudgeWeapon1StickySuccess", "xNudgeWeapon2StickySuccess", "xNudgeWeapon3StickySuccess"];
    public static NUDGE_WEAPONS: string[] = ["xNudgeWeapon1", "xNudgeWeapon2", "xNudgeWeapon3"];
    public static NUDGE_COUNTER: string = "xNudgeCounter";
    public static WIN_COUNTUP: string = "winCountup";
    public static WIN_COUNTUP_END: string = "winCountupEnd";
    public static EASTER_TILT: string = "easterTilt";
    public static CONTINUE_BUTTON: string = "continueButton";
    public static EASTER_BUTTON_MASH: string[] = ["easterButtonMash1", "easterButtonMash2", "easterButtonMash3", "easterButtonMash4", "easterButtonMash5", "easterButtonMash6", "easterButtonMash7", "easterButtonMash8", "easterButtonMash9"];
    public static BET_CHANGE: string[] = ["betChange01", "betChange02", "betChange03", "betChange04", "betChange05", "betChange06", "betChange07", "betChange08", "betChange09", "betChange10", "betChange11", "betChange12", "betChange13", "betChange14", "betChange15", "betChange16", "betChange17", "betChange18", "betChange19", "betChange20", "betChange21", "betChange22", "betChange23", "betChange24", "betChange25"];
    public static SHINY_BRUTE: string = "shinyBrute";
    public static SHINY_SUPER_BRUTE: string = "shinySuperBrute";

    //Feature Sounds
    public static FEATURE_NUDGE: string[] = ["feature1Xnudge", "feature2Xnudge", "feature4Xnudge"];
    public static FEATURE_BRUTE: string = "featureBrute";
    public static FEATURE_SUPER_BRUTE: string = "featureSuperBrute";
    public static FEATURE_FIFTY: string = "featureFiftyFifty";
    public static FEATURE_XBET: string = "featureXBet";
    public static FEATURE_OFF: string = "featureOff";

    //Scatter Sounds
    public static SCATTER_WIN_HIGHLIGHT: string = "scatterHighlight";
    public static SCATTER_ANTICIPATION: string = "scatterAnticipation";
    public static SCATTER_ANTICIPATION_FAIL: string = "scatterAnticipationFail";
    public static SCATTER_ANTICIPATION_WIN: string = "scatterAnticipationWin";
    public static SCATTER_ANTICIPATION_REEL_STOP: string = "scatterAnticipationReelStop";
    public static SCATTER_LANDS: string[] = ["scatter1Land", "scatter2Land", "scatter3Land", "scatter4Land"];

    //public static WINCAP_START: string = "wincapStart"
    private static _currentMusic: string;
    //storing sounds
    private static _nudgeLanding: string[] = [];
    private static _pointsToCounter: string[] = [];
    private static _nudgeMeterPoints: string[] = [];
    private static _betlineHighlights: string[] = ["", "", "", "", ""];
    private static _betlineHighlightsOverlayM: string[] = [];
    private static _isNudgePointHighlightPlaying: boolean = false;
    private static _isNudgeMeterPointsPlaying: boolean = false;
    private static _isBetlineHighlightsPlaying: boolean[] = [false, false, false, false, false];
    private static _isBetlineHighlightsOverlayMPlaying: boolean[] = [false, false, false, false, false];
    private static _isNudgePointerMoving: boolean = false;
    private static _copyBetlineHighlights: string[] = JSON.parse(JSON.stringify(this.BETLINE_HIGHLIGHTS));
    private static _copyBetlineHighlightsOverlay: string[] = JSON.parse(JSON.stringify(this.BETLINE_HIGHLIGHTS_OVERLAY_M));
    private static _isNudgeCounterBlastPlaying: boolean = false;
    private static _nudgeWeapons: boolean[] = [false, false, false];
    private static _nudgeSparks: string[] = [];
    private static _isNudgeStickyFailPlaying: boolean[] = [false, false, false];
    private static _isNudgeStickySuccessPlaying: boolean[] = [false, false, false];
    private _player: NolimitAudioPlayer;

    constructor() {
        this._player = <NolimitAudioPlayer>BruteForce.sound;
        this._player.showLogs(true);
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>BruteForce.sound;
    }

    public static switchMusic(conf: IPlayTrackConf, fadeInConf?: IFadeTrackConf, fadeOutConf?: IFadeTrackConf): void {
        if (conf.name === BruteForceSound._currentMusic) {
            return;
        }

        if (BruteForceSound._currentMusic != null) {
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = BruteForceSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = this._currentMusic;
                if (fade) {
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000,
                        onComplete: () => {
                            BruteForceSound.soundPlayer.stopTrack(fadeName);
                        }
                    });
                } else {
                    BruteForceSound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                BruteForceSound.soundPlayer.stopTrack(BruteForceSound._currentMusic);
            }
        }

        BruteForceSound.soundPlayer.playTrack(conf);
        if (fadeInConf) {
            BruteForceSound.soundPlayer.fadeTrack(fadeInConf);
        }
        BruteForceSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol: number, duration: number): void {
        BruteForceSound.soundPlayer.fadeTrack({
            name: BruteForceSound._currentMusic,
            to: vol,
            duration: duration
        });
    }


    public static playTrack(soundName: string, vol?: number, repeat?: number): NolimitHowl | undefined {
        return BruteForceSound.soundPlayer.playTrack({name: soundName, volume: vol, repeat: repeat});
    }

    public static fadeOutAndStopSound(fadeOutConf: IFadeTrackConf): void {
        const fade = BruteForceSound.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    BruteForceSound.soundPlayer.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            BruteForceSound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }

    public static fadeInAndStartSound(fadeOutConf: IFadeTrackConf): void {
        const fade = BruteForceSound.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    BruteForceSound.soundPlayer.playTrack({name: fadeOutConf.name, volume: fadeOutConf.to});
                }
            });
        } else {
            BruteForceSound.soundPlayer.playTrack({name: fadeOutConf.name});
        }
    }


    public static stopSound(name: string): void {
        BruteForceSound.soundPlayer.stopTrack(name);
    }

    public static playNudgeSound(index: number): void {
        const nudgeLanding: string = BruteForceSound.NUDGE_LANDING[index];
        if (!this._nudgeLanding.includes(nudgeLanding)) {
            this._nudgeLanding.push(nudgeLanding);
        }
        BruteForceSound.playTrack(this._nudgeLanding[this._nudgeLanding.length - 1]);
    }

    public static stopNudgeSound(): void {
        this._nudgeLanding.forEach((nudgeLanding: string) => {
            BruteForceSound.stopSound(nudgeLanding);
        })
        this._nudgeLanding = [];
    }

    public static playNudgePointHighlight(): void {
        if (!this._isNudgePointHighlightPlaying && !BruteForceGameConfig.nudgePresentationSecondSkip) {
            BruteForceSound.playTrack(BruteForceSound.NUDGE_POINTS_HIGHLIGHT);
            this._isNudgePointHighlightPlaying = true;
        }
    }

    public static stopNudgePointHighlight(): void {
        if (this._isNudgePointHighlightPlaying && BruteForceGameConfig.nudgePresentationSecondSkip) {
            BruteForceSound.stopSound(BruteForceSound.NUDGE_POINTS_HIGHLIGHT);
            this._isNudgePointHighlightPlaying = false;
        }
    }

    public static playMeterPoints(): void {
        if (!BruteForceGameConfig.nudgePresentationSecondSkip) {
            const meterPoints: string = ArrayHelper.getRandomValue(BruteForceSound.XNUDGE_METER_POINTS);
            this._nudgeMeterPoints.push(meterPoints);
            BruteForceSound.playTrack(this._nudgeMeterPoints[this._nudgeMeterPoints.length - 1]);
            this._isNudgeMeterPointsPlaying = true;
        }

    }

    public static stopMeterPoints(): void {
        if (BruteForceGameConfig.nudgePresentationSecondSkip && this._isNudgeMeterPointsPlaying) {
            this._nudgeMeterPoints.forEach((meterPoint: string) => {
                BruteForceSound.stopSound(meterPoint);
            });
            this._isNudgeMeterPointsPlaying = false;
        }
        this._nudgeMeterPoints = [];
    }

    public static playPointsToCounter(): void {
        if (!BruteForceGameConfig.nudgePresentationSecondSkip) {
            const pointsToCounter: string = ArrayHelper.getRandomValue(BruteForceSound.MOVE_POINTS_TO_COUNTER);
            this._pointsToCounter.push(pointsToCounter);
            BruteForceSound.playTrack(this._pointsToCounter[this._pointsToCounter.length - 1]);
            this._isNudgePointerMoving = true;
        }
    }

    public static stopPointsToCounter(): void {
        if (BruteForceSound._isNudgePointerMoving && BruteForceGameConfig.nudgePresentationSecondSkip) {
            this._pointsToCounter.forEach((point: string) => {
                BruteForceSound.stopSound(point);
            })
            this._isNudgePointerMoving = false;
        }
        this._pointsToCounter = [];
    }


    public static playBetlineHighlights(index: number): void {
        if (!BruteForceGameConfig.initialWinPresentationSkip && !this._isBetlineHighlightsPlaying[index]) {
            let betlineHighlights: string = ArrayHelper.getRandomValue(this._copyBetlineHighlights);
            for (let i: number = 0; i < this._copyBetlineHighlights.length; i++) {
                if (this._copyBetlineHighlights[i] === betlineHighlights) {
                    this._copyBetlineHighlights.splice(i, 1);
                }
            }
            this._betlineHighlights[index] = betlineHighlights;
            BruteForceSound.playTrack(this._betlineHighlights[index]);
            this._isBetlineHighlightsPlaying[index] = true;
        }

    }

    public static stopBetlineHighlights(): void {
        if (BruteForceGameConfig.initialWinPresentationSkip) {
            this._isBetlineHighlightsPlaying.forEach((isTypePlaying: boolean, index: number) => {
                if (isTypePlaying) {
                    BruteForceSound.stopSound(this._betlineHighlights[index]);
                    this._betlineHighlights[index] = "";
                }
            })
        }
        this._betlineHighlights = ["", "", "", "", ""];
    }


    public static playBetlineHighlightsOverlayM(groupType: number): void {
        if (!BruteForceGameConfig.initialWinPresentationSkip && !this._isBetlineHighlightsOverlayMPlaying[groupType]) {
            let betlineHighlightOverlays: string = ArrayHelper.getRandomValue(this._copyBetlineHighlightsOverlay);
            for (let i: number = 0; i < this._copyBetlineHighlightsOverlay.length; i++) {
                if (this._copyBetlineHighlightsOverlay[i] === betlineHighlightOverlays) {
                    this._copyBetlineHighlightsOverlay.splice(i, 1);
                }
            }
            this._betlineHighlightsOverlayM.push(betlineHighlightOverlays);
            BruteForceSound.playTrack(this._betlineHighlightsOverlayM[this._betlineHighlightsOverlayM.length - 1]);
            this._isBetlineHighlightsOverlayMPlaying[groupType] = true;
        }

    }

    public static stopBetlineHighlightsOverlayM(): void {
        if (BruteForceGameConfig.initialWinPresentationSkip) {
            this._isBetlineHighlightsOverlayMPlaying.forEach((isGroupMPlaying: boolean) => {
                if (isGroupMPlaying) {
                    BruteForceSound.stopSound(this._betlineHighlightsOverlayM[0]);
                    this._betlineHighlightsOverlayM.shift();
                }
            })
        }
        this._betlineHighlightsOverlayM = [];
    }


    public static meterEffectsReset() {
        this._nudgeMeterPoints = [];
        this._pointsToCounter = [];
        this._isNudgePointHighlightPlaying = false;
        this._isNudgeMeterPointsPlaying = false;
    }

    public static betlineEffectsReset(): void {
        this._betlineHighlights = ["", "", "", "", ""];
        this._betlineHighlightsOverlayM = [];
        this._isBetlineHighlightsPlaying = [false, false, false, false, false];
        this._isBetlineHighlightsOverlayMPlaying = [false, false, false, false, false];
        this._copyBetlineHighlights = JSON.parse(JSON.stringify(BruteForceSound.BETLINE_HIGHLIGHTS));
        this._copyBetlineHighlightsOverlay = JSON.parse(JSON.stringify(BruteForceSound.BETLINE_HIGHLIGHTS_OVERLAY_M));
    }

    public static playBigWinOutro() {
        const bigwinOutro: string = ArrayHelper.getRandomValue(BruteForceSound.BIGWIN_OUTROS);
        BruteForceSound.playTrack(bigwinOutro, 1);
    }

    public static playNudgeStickySuccess(name: string) {
        const type: number = +name.charAt(name.length - 1);
        if (!this._isNudgeStickySuccessPlaying[type - 1]) {
            BruteForceSound.playTrack(BruteForceSound.NUDGE_STICKY_SUCCESS[type - 1]);
            this._isNudgeStickySuccessPlaying[type - 1] = true;
        }
    }

    public static resetNudgeStickySound() {
        this._isNudgeStickySuccessPlaying = [false, false, false];
        this._isNudgeStickyFailPlaying = [false, false, false];
    }

    public static playNudgeStickyFail(name: string) {
        const type: number = +name.charAt(name.length - 1);
        if (!this._isNudgeStickyFailPlaying[type - 1]) {
            BruteForceSound.playTrack(BruteForceSound.NUDGE_STICKY_FAIL[type - 1]);
            this._isNudgeStickyFailPlaying[type - 1] = true;
        }
    }

    public static playNudgeCounterBlast(): void {
        if (!BruteForceGameConfig.nudgePresentationSecondSkip) {
            BruteForceSound.playTrack(BruteForceSound.NUDGE_COUNTER);
            this._isNudgeCounterBlastPlaying = true;
        }
    }

    public static stopNudgeCounterBlast(): void {
        if (this._isNudgeCounterBlastPlaying && BruteForceGameConfig.nudgePresentationSecondSkip) {
            BruteForceSound.stopSound(BruteForceSound.NUDGE_COUNTER);
            this._isNudgeCounterBlastPlaying = false;
        }
    }

    public static playNudgeWeapons(type: number) {
        if (!this._nudgeWeapons[type] && !BruteForceGameConfig.nudgePresentationSecondSkip) {
            BruteForceSound.playTrack(BruteForceSound.NUDGE_WEAPONS[type]);
            this._nudgeWeapons[type] = true;
        }
    }

    public static stopNudgeWeapons(): void {
        if (BruteForceGameConfig.nudgePresentationSecondSkip) {
            this._nudgeWeapons.forEach((isWeaponPlaying: boolean, index: number) => {
                if (isWeaponPlaying) {
                    BruteForceSound.stopSound(BruteForceSound.NUDGE_WEAPONS[index]);
                    this._nudgeWeapons[index] = false;
                }
            })
        }
        this._nudgeWeapons = [false, false, false];
    }

    public static playEasterButtonSound(type: string): void {
        let count: number = 0;
        const length: number = BruteForceSound.EASTER_BUTTON_MASH.length - 1;
        switch (type) {
            case "red":
                count = BruteForce.foregroundElements.redCount;
                break;
            case "yellow":
                count = BruteForce.foregroundElements.yellowCount + 3;
                break;
            case "blue":
                count = BruteForce.foregroundElements.blueCount + 6;
        }
        const easterButtonMash: string = count > length ? BruteForceSound.EASTER_BUTTON_MASH[6] : BruteForceSound.EASTER_BUTTON_MASH[count];
        BruteForceSound.playTrack(easterButtonMash);
    }

    public static playFeatureSound() {
        switch (BruteForce.apiPlugin.betFeatureController.getActiveBetFeature()?.name) {
            case "LUCKY_DRAW":
                BruteForceSound.playTrack(BruteForceSound.FEATURE_FIFTY);
                break;
            case "FREESPIN_3_SCATTERS":
                BruteForceSound.playTrack(BruteForceSound.FEATURE_BRUTE);
                break;
            case "FREESPIN_4_SCATTERS":
                BruteForceSound.playTrack(BruteForceSound.FEATURE_SUPER_BRUTE);
                break;
            case "BOOSTED_BET":
                BruteForceSound.playTrack(BruteForceSound.FEATURE_XBET);
                break;
            case "GUARANTEED_X_NUDGE":
                BruteForceSound.playTrack(BruteForceSound.FEATURE_NUDGE[0]);
                break;
            case "GUARANTEED_X_NUDGE_2":
                BruteForceSound.playTrack(BruteForceSound.FEATURE_NUDGE[1]);
                break;
            case "GUARANTEED_X_NUDGE_4":
                BruteForceSound.playTrack(BruteForceSound.FEATURE_NUDGE[2]);
                break;
            default:
                BruteForceSound.playTrack(BruteForceSound.FEATURE_OFF);
        }
    }

    public static playNudgeSparkSound(): void {
        if (!BruteForceGameConfig.nudgePresentationFirstSkip) {
            const sparkSound: string = ArrayHelper.getRandomValue(BruteForceSound.NUDGE_SPARKS);
            this._nudgeSparks.push(sparkSound);
            BruteForceSound.playTrack(sparkSound);
        }
    }

    public static stopNudgeSparkSound(): void {
        this._nudgeSparks.forEach((nudgeSpark: string) => {
            BruteForceSound.stopSound(nudgeSpark);
        })
        this._nudgeSparks = [];
    }

    private static createConfig(name: string, volume?: number, repeat?: number): IPlayTrackConf {
        return {
            name: name,
            volume: volume,
            repeat: repeat
        };
    }

}
